import store from "@/store";
import useGolfSamsungNavigation from "@/composables/useGolfsamsungNavigation";
import useModal from "@/composables/useModal";

const { alert } = useModal();

export function registerResponseInterceptor(axiosInstance) {
  axiosInstance.interceptors.response.use(
    (response) => {
      const userId = response.headers["x-session-user"] || null;
      if (!userId) {
        store.commit("removeMember");
      }

      return response;
    },
    async (error) => {
      if (!error?.response) {
        return Promise.reject(error);
      }

      const userId = error.response?.headers?.["x-session-user"] || null;
      if (!userId) {
        store.commit("removeMember");
      }

      if (error.response.status === 401) {
        await alert("로그인이 필요합니다.");
        useGolfSamsungNavigation().navigateLoginPage();
      }

      return Promise.reject(error);
    }
  );
}
